module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-02.92a2af97.png";